import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Printer, ArrowLeft, ZoomIn, ZoomOut } from 'lucide-react';

const TOTAL_PAGES = 26;

export default function SheerdriveReportPreview() {
  const [zoom, setZoom] = useState(100);

  const handlePrint = () => window.print();

  const pages = Array.from({ length: TOTAL_PAGES }, (_, i) => i + 1);

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .report-page { 
            page-break-after: always; 
            margin: 0 !important;
            padding: 0 !important;
            box-shadow: none !important;
          }
          .report-page:last-child { page-break-after: avoid; }
          .report-wrapper { background: white !important; padding: 0 !important; gap: 0 !important; }
          .report-page img { width: 100% !important; max-width: none !important; }
          body { margin: 0; padding: 0; }
        }
        @page { size: A4; margin: 0; }
      `}</style>

      {/* Sticky Action Bar */}
      <div className="no-print sticky top-0 z-50 bg-white/95 backdrop-blur border-b shadow-sm px-6 py-3 flex items-center justify-between" data-testid="report-action-bar">
        <div className="flex items-center gap-3">
          <button onClick={() => window.history.back()} className="text-gray-600 hover:text-gray-900 transition-colors">
            <ArrowLeft className="h-5 w-5" />
          </button>
          <h1 className="text-lg font-semibold text-gray-900">Sheerdrive Report Preview</h1>
          <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full font-medium">Sample — {TOTAL_PAGES} pages</span>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 border rounded-lg px-1">
            <button onClick={() => setZoom(z => Math.max(50, z - 10))} className="p-1.5 hover:bg-gray-100 rounded" data-testid="zoom-out-btn">
              <ZoomOut className="h-4 w-4 text-gray-600" />
            </button>
            <span className="text-xs font-medium text-gray-600 w-10 text-center">{zoom}%</span>
            <button onClick={() => setZoom(z => Math.min(150, z + 10))} className="p-1.5 hover:bg-gray-100 rounded" data-testid="zoom-in-btn">
              <ZoomIn className="h-4 w-4 text-gray-600" />
            </button>
          </div>
          <Button variant="outline" size="sm" onClick={handlePrint} data-testid="print-btn">
            <Printer className="h-4 w-4 mr-1.5" /> Print / Save PDF
          </Button>
        </div>
      </div>

      {/* Report Pages */}
      <div className="report-wrapper bg-gray-200 min-h-screen py-6 flex flex-col items-center gap-4" data-testid="report-container">
        {pages.map(pageNum => (
          <div
            key={pageNum}
            className="report-page bg-white shadow-lg"
            style={{ width: `${(210 * zoom) / 100}mm`, transition: 'width 0.2s ease' }}
            data-testid={`report-page-${pageNum}`}
          >
            <img
              src={`/sheerdrive-report/page_${String(pageNum).padStart(2, '0')}.png`}
              alt={`Report page ${pageNum}`}
              className="w-full block"
              loading={pageNum <= 3 ? 'eager' : 'lazy'}
            />
          </div>
        ))}
      </div>
    </>
  );
}
